import React from "react";
import { Routes, Route, Navigate, Outlet } from "react-router-dom";

import Login from "../mobile_pages/Login";
import AdminDashboard from "../mobile_pages/dashboard/AdminDashboard";
import ProjectDashboard from "../mobile_pages/dashboard/ProjectDashboard";
import SelectProject from "../mobile_pages/dashboard/SelectProject";
import CreateProject from "../mobile_pages/system/ProjectCreate";

import AdminRoute from "./AdminRoute";
import ProjectRoute from "./ProjectRoute";
import UserManage from "../mobile_pages/admin/UserManage";
import ProjectInfoManage from "../mobile_pages/admin/ProjectInfoManage";

import MobileLayout from "../components/layout/mobile/Layout";

import FourDLayout from "../mobile_pages/4D/FourDLayout";
import Project4DPage from "../mobile_pages/4D/Project4DPage";
import Project4DUploadPage from "../mobile_pages/4D/Project4DUploadForm";

import OverviewView from "../mobile_pages/overview/OverviewView";
import OverviewLayout from "../mobile_pages/overview/OverviewLayout";
import OverviewRegister from "../mobile_pages/overview/OverviewRegister";
import OverviewRegisterEdit from "../mobile_pages/overview/OverviewRegisterEdit";

import PermitList from "../mobile_pages/permit/List";
import PermitSchedule from "../mobile_pages/permit/Schedule";
// import PermitLayout from "../mobile_pages/permit/PermitLayout";
import PermitFormPage from "../mobile_pages/permit/FormPage";
import PermitView from "../mobile_pages/permit/PermitView";

import DocsData from "../mobile_pages/docs/Data";

import ConstDaily from "../mobile_pages/const/Daily";
import ConstDailyEditor from "../mobile_pages/const/DailyEditor";
import ConstDailyView from "../mobile_pages/const/DailyView";
import ConstDailyUserDefine from "../mobile_pages/const/UserDefine";

import ConstProgress from "../mobile_pages/const/Progress";
import ConstProgressNew from "../mobile_pages/const/Progress_new";
import ConstProgressView from "../mobile_pages/const/Progress_view";
import ConstUserTemplate from "../mobile_pages/const/UserTemplate";
import ConstUserTemplate_view from "../mobile_pages/const/UserTemplate_view";
import ConstPhoto from "../mobile_pages/const/Photo";
import ConstPhotoNew from "../mobile_pages/const/Photo_new";
import ConstOrderNew from "../mobile_pages/const/Order_new";
import ConstPhotoView from "../mobile_pages/const/Photo_view";
import ConstPhotoBoard from "../mobile_pages/const/PhotoBoard";
import ConstPhotoBoardView from "../mobile_pages/const/PhotoBoard_view";
import ConstWorkDetail from "../mobile_pages/const/WorkDetailPage";

import ConstOrder from "../mobile_pages/const/Order";
import ConstOrderView from "../mobile_pages/const/Order_view";
import ConstOrderComplete from "../mobile_pages/const/OrderComplete";
import ConstTest from "../mobile_pages/const/Test";
import ConstOrderCompleteNew from "../mobile_pages/const/OrderComplete_new";
import ConstOrderCompleteView from "../mobile_pages/const/OrderComplete_view";
import ConstReport from "../mobile_pages/const/Report";

import DesignRequest from "../mobile_pages/design/Request";
import DesignRequestNew from "../mobile_pages/design/Request_new";
import DesignRequestView from "../mobile_pages/design/Request_view";
import DesignDetail from "../mobile_pages/design/Detail";
import DesignLogs from "../mobile_pages/design/Logs";
import DesignFcrNew from "../mobile_pages/design/Fcr_new";
import DesignList from "../mobile_pages/design/Fcr";
import DesignFcrView from "../mobile_pages/design/Fcr_view";
import DesignFcnNew from "../mobile_pages/design/Fcn_new";
import DesignFcnView from "../mobile_pages/design/Fcn_view";
import DesignDcnNew from "../mobile_pages/design/Dcn_new";
import DesignDcnView from "../mobile_pages/design/Dcn_view";

import QualityInspectionNew from "../mobile_pages/quality/incoming/Incoming_new";
import QualityCheckListNew from "../mobile_pages/quality/process/Process_new";
import QualityNcrNew from "../mobile_pages/quality/ncr/Ncr_new";
import QualityCarNew from "../mobile_pages/quality/car/Car_new";
import QualityCreate from "../mobile_pages/quality/Create";
import QualityBoard from "../mobile_pages/quality/QualityBoard";
import QualityView from "../mobile_pages/quality/QualityView";

import SafetyBoard from "../mobile_pages/safety/SafetyBoard";
import SafetyChecklist from "../mobile_pages/safety/Checklist";
import SafetyLive from "../mobile_pages/safety/Live";
import SafetyViewRouter from "../mobile_pages/safety/SafetyView";
import SafetyCreate from "../mobile_pages/safety/Create";
import SafetyForm from "../mobile_pages/safety/Form";

import MaterialsCreate from "../mobile_pages/materials/Create";
import MaterialsBoard from "../mobile_pages/materials/MaterialBoard";
import MaterialsForm from "../mobile_pages/materials/MaterialsForm";
import MaterialsInout from "../mobile_pages/materials/inout/Inout";
import MaterialsCheck from "../mobile_pages/materials/check/Check";
import MaterialsStock from "../mobile_pages/materials/Stock";
import MaterialView from "../mobile_pages/materials/MaterialView";
import MaterialsUserTemplateNew from "../mobile_pages/materials/MaterialsUserTemplateNew";

import ContractInfo from "../mobile_pages/contract/Info";
import ContractInfoNew from "../mobile_pages/contract/Info_new";
import ContractInfoView from "../mobile_pages/contract/Info_view";
import ContractSub from "../mobile_pages/contract/Sub";
import ContractSubNew from "../mobile_pages/contract/Sub_new";
import ContractSubView from "../mobile_pages/contract/Sub_view";
import ContractResult from "../mobile_pages/contract/Result";
import ContractCost from "../mobile_pages/contract/Cost";
import ContractCostNew from "../mobile_pages/contract/Cost_new";
import ContractCostView from "../mobile_pages/contract/Cost_view";
import ContractBill from "../mobile_pages/contract/Bill";
import ContractBillNew from "../mobile_pages/contract/Bill_new";
import ContractBillView from "../mobile_pages/contract/Bill_view";

import MeetingPlanShellMobile from "../mobile_pages/meeting/MeetingPlanShellMobile";
import MeetingRoomManage from "../mobile_pages/meeting/MeetingRoomManage";
import MobileScheduleCalendar from "../mobile_pages/meeting/MobileScheduleCalendar";

import Notice from "../mobile_pages/notice/Notice";
import NoticeView from "../mobile_pages/notice/Notice_view";
import NoticeCreate from "../mobile_pages/notice/Notice_create";

import ProcessUpload from "../mobile_pages/process/upload";
import ProcessCon from "../mobile_pages/process/Construction";
import ProcessProgress from "../mobile_pages/process/Progress";
import ProcessMta from "../mobile_pages/process/Mta";
import ProcessMilestone from "../mobile_pages/process/Milestone";

import ApprovalRequest from "../mobile_pages/approval/Request";
import ApprovalRequestEdit from "../mobile_pages/approval/Type_edit";
import ApprovalDocs from "../mobile_pages/approval/Docs";
import ApprovalDocsView from "../mobile_pages/approval/Docs_view";
import ApprovalMydocs from "../mobile_pages/approval/Mydocs";
import ApprovalTypeList from "../mobile_pages/approval/TypeList";

import SystemUser from "../mobile_pages/system/User";
import SystemUserAdd from "../mobile_pages/system/User_add";
import SystemUserList from "../mobile_pages/system/User_list";
import SystemUserCompany from "../mobile_pages/system/User_company";
import SystemCompanyAdd from "../mobile_pages/system/User_company_add";
import SystemUserPcp from "../mobile_pages/system/User_pcp";
import SystemUserDepartment from "../mobile_pages/system/User_department";
import SystemUserPosition from "../mobile_pages/system/User_position";
import SystemGrant from "../mobile_pages/system/Grant";
import SystemProjectModify from "../mobile_pages/system/ProjectModify";
import MobileMyPage from "../mobile_pages/system/MyPage";

import PcModuleProd from "../mobile_pages/pc_module/Prod";
import PcModuleMatl from "../mobile_pages/pc_module/Matl";
import PcModuleQuality from "../mobile_pages/pc_module/Quality";
import PcModuleStock from "../mobile_pages/pc_module/Stock";

import DocsLayout from "../mobile_pages/docs/DocsLayout";
import ConstLayout from "../mobile_pages/const/ConstLayout";
import DesignLayout from "../mobile_pages/design/DesignLayout";
import QualityLayout from "../mobile_pages/quality/QualityLayout";
import SafetyLayout from "../mobile_pages/safety/SafetyLayout";
import MaterialsLayout from "../mobile_pages/materials/MaterialsLayout";
import ContractLayout from "../mobile_pages/contract/ContractLayout";
import MeetingLayout from "../mobile_pages/meeting/MeetingLayout";
import ProcessLayout from "../mobile_pages/process/ProcessLayout";
import ApprovalLayout from "../mobile_pages/approval/ApprovalLayout";
import SystemLayout from "../mobile_pages/system/SystemLayout";
import PcmoduleLayout from "../mobile_pages/pc_module/PcmoduleLayout";
import PermitLayout from "../mobile_pages/permit/PermitLayout";
import DelayPrediction from "../components/process/DelayPrediction";

function MobileAppRouter() {
  return (
    <Routes>
      <Route path="/delay" element={<DelayPrediction />} />

      <Route path="/login" element={<Login />} />

      <Route element={<AdminRoute />}>
        <Route path="/admin/users" element={<UserManage />} />
        <Route path="/admin" element={<AdminDashboard />} />
        <Route
          path="/admin/projects/:projectId/edit"
          element={<ProjectInfoManage />}
        />
      </Route>

      {/* 헤더추가, 메뉴바 없음 */}
      <Route element={<ProjectRoute />}>
        <Route path="/create-project" element={<CreateProject />} />
        <Route path="/select-project" element={<SelectProject />} />
        <Route
          path="/project/:projectId/system/select-project/"
          element={<Navigate to="/select-project/" replace />}
        />{" "}
        {/* 시스템 관리 -> 전체 프로젝트 관리로 이동 */}
      </Route>

      {/* 헤더, 메뉴바 포함 */}
      <Route element={<MobileLayout />}>
        <Route element={<ProjectRoute />}>
          <Route path="/project/:id" element={<ProjectDashboard />} />

          <Route path="/project/:id/overview" element={<OverviewLayout />}>
            <Route index element={<Navigate to="view" replace />} />
            <Route path="view" element={<OverviewView />} />
            <Route path="register" element={<OverviewRegister />} />
            <Route path="register/edit" element={<OverviewRegisterEdit />} />
          </Route>

          <Route path="/project/:id/permit" element={<PermitLayout />}>
            <Route path="list" element={<PermitList />} />
            <Route path="schedule" element={<PermitSchedule />} />
            <Route path="new" element={<PermitFormPage />} />
            <Route path="edit/:permitId" element={<PermitFormPage />} />
            <Route path="view/:permitId" element={<PermitView />} />
          </Route>

          <Route path="/project/:id/docs" element={<DocsLayout />}>
            <Route index element={<Navigate to="data" replace />} />
            <Route path="data" element={<DocsData />} />
          </Route>

          <Route path="/project/:id/const" element={<ConstLayout />}>
            <Route path="daily" element={<ConstDaily />} />
            <Route path="daily/new" element={<ConstDailyEditor />} />
            <Route path="daily/:dns/" element={<ConstDailyEditor />} />
            <Route path="daily/:dns/view" element={<ConstDailyView />} />
            <Route path="userDefine" element={<ConstDailyUserDefine />} />
            <Route path="progress" element={<ConstProgress />} />
            <Route path="progress/new" element={<ConstProgressNew />} />
            <Route path="progress/:dns" element={<ConstProgressNew />} />
            <Route path="progress/:dns/view" element={<ConstProgressView />} />
            <Route path="userTemplate" element={<ConstUserTemplate />} />
            <Route
              path="userTemplate/view/:templateId"
              element={<ConstUserTemplate_view />}
            />
            <Route
              path="userTemplate/new"
              element={<ConstUserTemplate_view />}
            />
            <Route path="photo" element={<ConstPhoto />} />
            <Route path="photo/new" element={<ConstPhotoNew />} />
            <Route path="photo/view/:photoId" element={<ConstPhotoView />} />
            <Route path="photoboard" element={<ConstPhotoBoard />} />
            <Route
              path="photoboard/view/:photoboardId"
              element={<ConstPhotoBoardView />}
            />
            <Route path="order" element={<ConstOrder />} />
            <Route path="order/new" element={<ConstOrderNew />} />
            <Route path="order/:dns" element={<ConstOrderNew />} />
            <Route
              path="order/:workorderId/view"
              element={<ConstOrderView />}
            />
            <Route path="ordercomplete" element={<ConstOrderComplete />} />
            <Route
              path="ordercomplete/new"
              element={<ConstOrderCompleteNew />}
            />
            <Route
              path="ordercomplete/:dns"
              element={<ConstOrderCompleteNew />}
            />
            <Route
              path="ordercomplete/:completionreportId/view"
              element={<ConstOrderCompleteView />}
            />
            <Route path="report" element={<ConstReport />} />
            <Route path="workdetails" element={<ConstWorkDetail />} />
          </Route>

          <Route path="/project/:id/design" element={<DesignLayout />}>
            <Route path="request" element={<DesignRequest />} />
            <Route path="request/new" element={<DesignRequestNew />} />
            <Route path="request/:dns" element={<DesignRequestView />} />
            <Route path="detail" element={<DesignDetail />} />
            <Route path="logs" element={<DesignLogs />} />
            <Route path="list" element={<DesignList />} />
            <Route path="list/:docType" element={<DesignList />} />
            <Route path="fcn/new" element={<DesignFcnNew />} />
            <Route path="fc/new" element={<DesignFcrNew />} />
            <Route path="fcr/new" element={<DesignFcrNew />} />
            <Route path="dcn/new" element={<DesignDcnNew />} />
            <Route path="fcn/:dns" element={<DesignFcnNew />} />
            <Route path="fc/:dns" element={<DesignFcrNew />} />
            <Route path="fcr/:dns" element={<DesignFcrNew />} />
            <Route path="dcn/:dns" element={<DesignDcnNew />} />
            <Route path="fcr/:dns/view" element={<DesignFcrView />} />
            <Route path="fcn/:dns/view" element={<DesignFcnView />} />
            <Route path="dcn/:dns/view" element={<DesignDcnView />} />
            {/* 설계 모듈 내 결재문서 (APP) */}
            <Route path="APP/:dns/view" element={<ApprovalDocsView />} />
          </Route>

          <Route path="/project/:id/quality" element={<QualityLayout />}>
            <Route path="create" element={<QualityCreate />} />
            <Route path="qualityboard" element={<QualityBoard />} />
            <Route path="list/all" element={<QualityBoard />} />
            <Route path="list/:boardType" element={<QualityBoard />} />
            <Route path="incoming/new" element={<QualityInspectionNew />} />
            <Route path="process/new" element={<QualityCheckListNew />} />
            <Route path="ncr/new" element={<QualityNcrNew />} />
            <Route path="car/new" element={<QualityCarNew />} />
            <Route path="incoming/:dns" element={<QualityInspectionNew />} />
            <Route path="process/:dns" element={<QualityCheckListNew />} />
            <Route path="ncr/:dns" element={<QualityNcrNew />} />
            <Route path="car/:dns" element={<QualityCarNew />} />
            <Route path=":context/:dns/view" element={<QualityView />} />
          </Route>

          <Route path="/project/:id/safety" element={<SafetyLayout />}>
            <Route index element={<Navigate to="board" replace />} />
            <Route path="create" element={<SafetyCreate />} />
            <Route path="form/:mode" element={<SafetyForm />} />
            <Route path="board/" element={<SafetyBoard />} />
            <Route path="board/:doc_type" element={<SafetyBoard />} />
            <Route path="calendar" element={<SafetyChecklist />} />
            <Route path="live" element={<SafetyLive />} />
            {/* 신규 라우트 - 데스크탑과 일치하는 URL 패턴 */}
            <Route path="scar/new" element={<SafetyForm />} />
            <Route path="report/new" element={<SafetyForm />} />
            <Route path="check/new" element={<SafetyForm />} />
            <Route path="riskcheck/new" element={<SafetyForm />} />
            <Route path="incident/new" element={<SafetyForm />} />
            <Route path="scar/:dns" element={<SafetyForm />} />
            <Route path="report/:dns" element={<SafetyForm />} />
            <Route path="check/:dns" element={<SafetyForm />} />
            <Route path="riskcheck/:dns" element={<SafetyForm />} />
            <Route path="incident/:dns" element={<SafetyForm />} />

            <Route
              path=":doc_type/:dns/view"
              element={<SafetyViewRouter withSidebar />}
            />
          </Route>
          {/* 
          <Route
            path="/project/:id/materials/:context/:postId/view"
            element={<MaterialView />}
          />
          <Route
            path="/project/:id/materials/:context/forms/:formId"
            element={<MaterialView />}
          /> */}

          <Route path="/project/:id/materials" element={<MaterialsLayout />}>
            <Route index element={<Navigate to="list/all" replace />} />
            <Route path="create" element={<MaterialsCreate />} />
            <Route path=":context/:postId/view" element={<MaterialView />} />
            <Route path=":context/forms/:formId" element={<MaterialView />} />
            <Route path="materialboard" element={<MaterialsBoard />} />
            <Route path="list/:formType" element={<MaterialsBoard />} />
            <Route path="stock" element={<MaterialsStock />} />
            {/* 웹사이트와 호환되는 라우팅 */}
            <Route path="ps/new" element={<MaterialsForm />} />
            <Route path="po/new" element={<MaterialsForm />} />
            <Route path="qc/new" element={<MaterialsForm />} />
            <Route path="ck/new" element={<MaterialsForm />} />
            <Route path="gr/new" element={<MaterialsForm />} />
            <Route path="gi/new" element={<MaterialsForm />} />
            {/* 기존 모바일 라우팅 (하위 호환성) */}
            <Route path="plan/new" element={<MaterialsForm />} />
            <Route path="order/new" element={<MaterialsForm />} />
            <Route path="check/new" element={<MaterialsForm />} />
            <Route path="inout/new" element={<MaterialsForm />} />
            <Route path="plan/:dns" element={<MaterialsForm />} />
            <Route path="order/:dns" element={<MaterialsForm />} />
            <Route path="check/:dns" element={<MaterialsForm />} />
            <Route path="out/:dns" element={<MaterialsForm />} />
            <Route path="in/:dns" element={<MaterialsForm />} />
            <Route path="ps/:dns" element={<MaterialsForm />} />
            <Route path="po/:dns" element={<MaterialsForm />} />
            <Route path="qc/:dns" element={<MaterialsForm />} />
            <Route path="ck/:dns" element={<MaterialsForm />} />
            <Route path="gr/:dns" element={<MaterialsForm />} />
            <Route path="gi/:dns" element={<MaterialsForm />} />
            <Route path="check" element={<MaterialsCheck />} />
            <Route path="inout" element={<MaterialsInout />} />
            <Route path="template/new" element={<MaterialsUserTemplateNew />} />
          </Route>

          <Route path="/project/:id/contract" element={<ContractLayout />}>
            <Route path="info" element={<ContractInfo />} />
            <Route path="info/new" element={<ContractInfoNew />} />
            <Route
              path="info/view/:contractId"
              element={<ContractInfoView />}
            />
            <Route path="sub" element={<ContractSub />} />
            <Route path="sub/new" element={<ContractSubNew />} />
            <Route path="sub/view" element={<ContractSubView />} />
            <Route path="result" element={<ContractResult />} />
            <Route path="cost" element={<ContractCost />} />
            <Route path="cost/list" element={<ContractCost />} />
            <Route path="cost/new" element={<ContractCostNew />} />
            <Route path="cost/view" element={<ContractCostView />} />
            <Route path="bill" element={<ContractBill />} />
            <Route path="bill/new" element={<ContractBillNew />} />
            <Route path="bill/view" element={<ContractBillView />} />
          </Route>

          <Route path="/project/:id/meeting" element={<Outlet />}>
            <Route path="plan" element={<MeetingPlanShellMobile />} />
            <Route path="rooms" element={<MeetingRoomManage />} />
            {/* 일정 관리 */}
            <Route path="schedule" element={<MobileScheduleCalendar />} />
            {/* 공지 */}
            <Route path="notice" element={<OverviewLayout />}>
              <Route index element={<Notice />} />
              <Route path="list" element={<Notice />} />
              <Route path="create" element={<NoticeCreate />} />
              <Route path="new" element={<NoticeCreate />} />
              <Route path=":noticeId/view" element={<NoticeView />} />
            </Route>
            {/* 공통 문서 URL: /project/:id/meeting/:doc_type/:dns/view
               meeting 모듈도 plan/dns 뷰를 MeetingPlanShellMobile이 직접 처리 */}
            <Route
              path=":doc_type/:dns/view"
              element={<MeetingPlanShellMobile />}
            />
          </Route>

          <Route path="/project/:id/process" element={<ProcessLayout />}>
            <Route path="upload" element={<ProcessUpload />} />
            <Route path="construction" element={<ProcessCon />} />
            <Route path="progress" element={<ProcessProgress />} />
            <Route path="mta" element={<ProcessMta />} />
            <Route path="milestone" element={<ProcessMilestone />} />
          </Route>

          <Route path="/project/:id/approval" element={<ApprovalLayout />}>
            <Route index element={<ApprovalDocs />} />
            <Route path=":type/:dns/view" element={<ApprovalDocsView />} />
            <Route path="request/new" element={<ApprovalRequest />} />
            <Route path=":type/:dns" element={<ApprovalRequest />} />
            <Route path="mydocs" element={<ApprovalMydocs />} />
            <Route path="docs" element={<ApprovalDocs />} />
            <Route path="type" element={<ApprovalTypeList />} />
            <Route path="type/:typeId" element={<ApprovalRequestEdit />} />
          </Route>

          <Route path="/project/:id/system" element={<SystemLayout />}>
            <Route path="user" element={<SystemUser />} />
            <Route path="user/add" element={<SystemUserAdd />} />
            <Route path="user/list" element={<SystemUserList />} />
            <Route path="user/detail/:userId" element={<SystemUser />} />
            <Route path="user/company" element={<SystemUserCompany />} />
            <Route path="company/add" element={<SystemCompanyAdd />} />
            <Route path="user/pcp" element={<SystemUserPcp />} />
            <Route path="user/department" element={<SystemUserDepartment />} />
            <Route path="user/position" element={<SystemUserPosition />} />
            <Route path="grant" element={<SystemGrant />} />
            <Route path="modify" element={<SystemProjectModify />} />
            <Route path="mypage" element={<MobileMyPage />} />
          </Route>

          <Route path="/project/:id/pcmodule" element={<PcmoduleLayout />}>
            <Route path="prod" element={<PcModuleProd />} />
            <Route path="matl" element={<PcModuleMatl />} />
            <Route path="quality" element={<PcModuleQuality />} />
            <Route path="stock" element={<PcModuleStock />} />
          </Route>

          <Route path="/project/:id/4d" element={<FourDLayout />}>
            <Route index element={<Project4DPage />} />
            <Route path="upload" element={<Project4DUploadPage />} />
          </Route>
        </Route>
      </Route>

      <Route path="/" element={<Navigate to="/login" />} />
    </Routes>
  );
}

export default MobileAppRouter;
